import Vue from "vue";
import VueI18n from "vue-i18n";
import en from "./lang/en";
import zh from "./lang/zh";
import zhTW from "./lang/zh-TW";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en", // 默认中文
  messages: {
    en,
    zh,
    zhTW,
  },
});

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js